import { Link } from 'react-router-dom';

export const Logo = ({ size = 'lg', showText = true, disabled = false }) => {
  const sizes = {
    sm: 'h-7 w-full',
    md: 'h-9 w-full',
    lg: 'h-11 w-full',
  };

  // const textSizes = {
  //   sm: 'text-lg',
  //   md: 'text-xl',
  //   lg: 'text-2xl',
  // };

  return disabled ? (
    <div className="flex items-center gap-2.5 group">
      <img 
        src={'/logos/PayLink_logo_transparent.png'} 
        alt="PayLink Negdi Logo" 
        className={`${sizes[size]} object-contain`}
      />
    </div>
  ) : (
    <Link to="/" className="flex items-center gap-2.5 group">
      <img 
        src={'/logos/PayLink_logo_transparent.png'} 
        alt="PayLink Negdi Logo" 
        className={`${sizes[size]} object-contain`}
      />
      {/* {showText && (
        <span className={`${textSizes[size]} font-bold text-foreground`}>
          Negdi<span className="text-primary">LinkPay</span>
        </span>
      )} */}
    </Link>
  );
};
